import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FilterService } from '@progress/kendo-angular-grid';
import { FormBuilder } from '@angular/forms';
import { Logger } from '@app/core';
import { CustomKendoFilter } from '@app/shared/kendo/custom-kendo-filter';

const log = new Logger('KendoIndustrySelectComponent');

@Component({
  selector: 'app-kendo-industry-select',
  templateUrl: './kendo-industry-select.component.html',
  styleUrls: ['./kendo-industry-select.component.scss'],
})
export class KendoIndustrySelectComponent extends CustomKendoFilter implements OnInit, OnChanges {
  @Input() field = 'industry_id';

  constructor(private formBuilder: FormBuilder, filterService: FilterService) {
    super(filterService);
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      industry_id: [null],
      industry: [null],
    });

    const industry = this.getObjectFromStorage(this.field, 'industries');

    if (industry) {
      setTimeout(() => {
        this.form.patchValue({
          industry: industry,
          industry_id: industry.id,
        });
      });
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // Изчиства формата
    // Използва се, за да чисти филтрите, когато се сетне null state на таблицата
    if (this.form && changes && changes.filter && !changes.filter.currentValue) {
      this.form.reset();
    }
  }

  onSelect(event: any) {
    CustomKendoFilter.pushObjectInStorage(event, 'industries');

    this.filter = this.removeFilter(this.field);

    const filters = [];
    if (event) {
      filters.push({
        field: this.field,
        operator: 'eq',
        value: event.id,
      });
    }

    const root = this.filter || {
      logic: 'and',
      filters: [],
    };

    if (filters.length) {
      root.filters.push(...filters);
    }
    this.filterService.filter(root);
    log.debug('filters', filters);
  }
}
